import { keyBy } from 'lodash';
import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

export const selectLoanRolesV2 = createSelector(getSystem, ({ loanRolesV2 }) => loanRolesV2 ?? []);

export const selectLoanRolesByKeysV2 = createSelector(selectLoanRolesV2, loanRoles =>
  keyBy(loanRoles, 'id'),
);

export const selectLoanRolesOptionsV2 = memoizeOne(loanRolesToExclude =>
  createSelector(selectLoanRolesV2, loanRoles => {
    const filteredLoanRoles = loanRolesToExclude?.length
      ? loanRoles.filter(({ id }) => !loanRolesToExclude.includes(id))
      : loanRoles;

    return filteredLoanRoles.map(loanRole => ({
      ...loanRole,
      value: loanRole.id,
      potentialUsers: loanRole.potentialUsers?.map(user => ({
        name: `${user.firstName} ${user.lastName}`,
        value: user.id,
        ...user,
      })),
    }));
  }),
);

export const selectLoanRoleUsersOptionsV2 = memoizeOne(loanRoleId =>
  createSelector(selectLoanRolesOptionsV2(), loanRoles => {
    const loanRole = loanRoles?.find(({ id }) => id === loanRoleId);

    if (!loanRole) {
      return [];
    }

    return loanRole.potentialUsers;
  }),
);
